import { useQuery } from '@tanstack/react-query';
import { getProjects } from '@services/projects.service';
import { useAuthStore } from '@stores/auth.store';

export const PROJECTS_QUERY_KEY = ['projects'];

export const useProjects = (params = {}) => {
    const userId = useAuthStore((s) => s.user?.id ?? s.user?._id ?? null);
    return useQuery({
        queryKey: [...PROJECTS_QUERY_KEY, userId, params],
        queryFn: () => getProjects(params),
    });
};
